(() => {

  const init = () => {
    $('body').on('change', '.js-phone-format', phoneFormat)
    $('body').on('change', '.js-email-change', emailChange)
  }
  $(init);

  const phoneFormat = (e) => {
    e.preventDefault();
    $ele = $(e.currentTarget);
    $ele.val(z2hNum($ele.val()))
    $ele.val(removeHyphen($ele.val()))
  }

  const emailChange = (e) => {
    e.preventDefault();
    $ele = $(e.currentTarget);
    $($ele.data('email-confirmation')).val('')
  }

  const z2hNum = (str) => {
    return str.replace(/[０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    })
  }
  const removeHyphen = (str) => {
    return str.replace(/(\-|ー)/g, '');
  }
  const onlyNum = (str) => {
    return str.replace(/[^0-9]/g, '');
  }
})();

